// IframeViewer.js
'use client';
import { connect } from 'react-redux';

import IframeViewer from '../page/IframeViewer.jsx';

import withRouter from '../component/WithRouter.jsx';
import {
  IFRAME_ALLOWED_URLS,
  IFRAME_BYPASS_PROXY_WHITELIST_DOMAINS,
  IFRAME_URL_PREFIX,
  IFRAME_STATIC_URL_PREFIX,
  IFRAME_POST_TOKEN_DOMAINS,
  API_URL_PREFIX,
  DOMAIN_TRACKER_LABEL,
  PUBLIC_URL_ENCRYPT_KEYS,
} from '../RemoteConfigKeys.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getMeData from '../selector/getMeData.js';
import getOperationData from '../selector/getOperationData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getIsRemoteConfigMerged from '../selector/getIsRemoteConfigMerged.js';
import { push, replace } from '../action/navigationAction.js';
import toggleModal from '../action/toggleModal.js';
import fetchDomainTrackerResource from '../action/fetchDomainTrackerResource.js';
import checkRiskGate from '../action/checkRiskGate.js';
import addvalue from '../action/addvalue.js';

const mapStateToProps = state => {
  const meId = getMeData(state, 'id');
  const domainTrackerLabel = getRemoteConfigData(state, DOMAIN_TRACKER_LABEL);
  const domainTrackerType = 'cdn_enc';

  const allowURL = getRemoteConfigData(state, IFRAME_ALLOWED_URLS);
  const bypassProxyURL = getRemoteConfigData(
    state,
    IFRAME_BYPASS_PROXY_WHITELIST_DOMAINS
  );

  // Get fastest CDN domain from domain tracker
  const fastestResourceId = getOperationData(state, [
    'domainTracker',
    domainTrackerType,
    domainTrackerLabel,
    'fastestResource',
  ]);

  const resourceList = getOperationData(state, [
    'domainTracker',
    domainTrackerType,
    domainTrackerLabel,
    'resourceList',
  ]);

  const fastestCdnDomain =
    fastestResourceId && resourceList?.[fastestResourceId]?.url;

  // Check if domain tracker fetch has completed (success or error)
  const isDomainTrackerFetched = getNetworkingData(
    state,
    ['domainTracker', domainTrackerType, domainTrackerLabel, 'fastestResource'],
    'isFetched'
  );

  return {
    meId,
    allowURL,
    bypassProxyURL,
    iframeUrlPrefix: getRemoteConfigData(state, IFRAME_URL_PREFIX),
    iframeStaticUrlPrefix: getRemoteConfigData(state, IFRAME_STATIC_URL_PREFIX),
    meToken: getMeData(state, 'token'),
    tokenWhitelistDomains: getRemoteConfigData(
      state,
      IFRAME_POST_TOKEN_DOMAINS
    ),
    apiUrlPrefix: getRemoteConfigData(state, API_URL_PREFIX),
    publicUrlEncryptKeys: getRemoteConfigData(state, PUBLIC_URL_ENCRYPT_KEYS),
    iconBaseUrl: fastestCdnDomain,
    domainTrackerLabel,
    domainTrackerType,
    isDomainTrackerFetched,
    isRemoteConfigMerged: getIsRemoteConfigMerged(state),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    push: (...args) => dispatch(push(...args)),
    replace: (...args) => dispatch(replace(...args)),
    toggleModal: (...args) => dispatch(toggleModal(...args)),
    fetchDomainTrackerResource: (...args) =>
      dispatch(fetchDomainTrackerResource(...args)),
    checkRiskGate: (...args) => dispatch(checkRiskGate(...args)),
    addvalue: (...args) => dispatch(addvalue(...args)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(IframeViewer)
);
